<template>
  <div class="d-flex actions-cell">
    <button
      class="btn px-3 btn-sm btn-primary mx-2"
      :disabled="row.progress !== 100"
      @click="$emit('downloadExcelFile')"
    >
      {{ $t('order-confirmation.calls.excel.table.download') }}
    </button>
    <router-link
      :to="{
        name: 'order-confirmation-excel-call-file',
        params: { id: row.id }
      }"
    >
      <button class="btn px-3 btn-sm btn-primary" v-if="status === 'failed'">
        {{ $t('order-confirmation.calls.excel.table.show-corrupted') }}
      </button>
    </router-link>

    <span v-if="row.progress < 100 && ['ready', 'paused'].includes(status)">
      <span v-if="isLoading">
        <half-circle-spinner
          slot="loading"
          :animation-duration="1500"
          :size="25"
          color="#74b9ff"
          class="mx-auto"
        />
      </span>
      <div class="d-flex" v-else>
        <button
          v-if="status === 'paused'"
          class="btn btn-text shadow-none p-2"
          @click="progress()"
        >
          <i class="fa fa-play" aria-hidden="true"></i>
        </button>
        <button
          v-else-if="pauseable && status === 'ready'"
          class="btn btn-text shadow-none p-2"
          @click="pause()"
        >
          <i class="fa fa-pause" aria-hidden="true"></i>
        </button>
      </div>
    </span>

    <button
      class="btn px-3 btn-sm btn-primary"
      @click="$emit('toggleDetails')"
      v-if="row.callsDates && row.callsDates.length > 0"
    >
      <i :class="isDetailsVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
    </button>
  </div>
</template>

<script>
import orderConfirmationService from '../../../services/orderConfirmation.service'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'
export default {
  components: {
    HalfCircleSpinner
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    isDetailsVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      status: 'ready',
      pauseable: false
    }
  },
  watch: {
    row() {
      this.status = this.row.status
      this.pauseable = this.row.pauseable
    }
  },
  mounted() {
    this.status = this.row.status
    this.pauseable = this.row.pauseable
  },
  methods: {
    async progress() {
      this.isLoading = true
      try {
        const res = await orderConfirmationService.resumeCallFile(this.row.id)
        this.status = 'ready'
        this.$emit('changeStatus', 'ready')
      } catch (error) {
        this.toast(error.response.data.message, {
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    async pause() {
      this.isLoading = true
      try {
        const res = await orderConfirmationService.pauseCallFile(this.row.id)
        this.status = 'paused'
        this.$emit('changeStatus', 'paused')
      } catch (error) {
        this.toast(error.response.data.message, {
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
